import { createContext } from "react";

export const ServiceSignupContext = createContext(null);
